import { Link } from 'react-router-dom';
import { useState } from 'react';

export default function Footer() {
  const [showSuggestionForm, setShowSuggestionForm] = useState(false);
  const [showFeedbackForm, setShowFeedbackForm] = useState(false);
  const [formData, setFormData] = useState({
    animeSeries: '',
    characterName: '',
    details: ''
  });
  const [feedbackData, setFeedbackData] = useState({
    feedbackType: 'feedback',
    subject: '',
    message: ''
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState<'idle' | 'success' | 'error'>('idle');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('animeSeries', formData.animeSeries);
      formBody.append('characterName', formData.characterName);
      formBody.append('details', formData.details);

      const response = await fetch('https://readdy.ai/api/form/d5jep3n9u36dslcgh8n0', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFormData({
          animeSeries: '',
          characterName: '',
          details: ''
        });
        setTimeout(() => {
          setShowSuggestionForm(false);
          setSubmitStatus('idle');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleFeedbackSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitStatus('idle');

    try {
      const formBody = new URLSearchParams();
      formBody.append('feedbackType', feedbackData.feedbackType);
      formBody.append('subject', feedbackData.subject);
      formBody.append('message', feedbackData.message);

      const response = await fetch('https://readdy.ai/api/form/d5o173fecauet1j8bb6g', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: formBody.toString()
      });

      if (response.ok) {
        setSubmitStatus('success');
        setFeedbackData({
          feedbackType: 'feedback',
          subject: '',
          message: ''
        });
        setTimeout(() => {
          setShowFeedbackForm(false);
          setSubmitStatus('idle');
        }, 2000);
      } else {
        setSubmitStatus('error');
      }
    } catch (error) {
      setSubmitStatus('error');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <footer className="bg-gradient-to-r from-pink-500 to-purple-600 text-white py-12">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div>
              <h3 className="text-lg font-bold mb-4">Anime HOT or NOT</h3>
              <p className="text-sm text-white/80">
                Rate your favorite anime characters and discover the hottest ones!
              </p>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">Quick Links</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/rate" className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap">
                    Rate Characters
                  </Link>
                </li>
                <li>
                  <Link to="/top10" className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap">
                    Top 10 Rankings
                  </Link>
                </li>
                <li>
                  <Link to="/top5users" className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap">
                    Top Raters
                  </Link>
                </li>
                <li>
                  <button
                    onClick={() => setShowSuggestionForm(true)}
                    className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap cursor-pointer bg-transparent border-0 p-0"
                  >
                    Suggest Character/Series
                  </button>
                </li>
                <li>
                  <Link to="/about" className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap">
                    About Us
                  </Link>
                </li>
                <li>
                  <Link to="/faq" className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap">
                    FAQ
                  </Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">Community</h4>
              <ul className="space-y-2">
                <li>
                  <a href="https://discord.gg/UUMhp6W2P6" target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap">
                    Discord
                  </a>
                </li>
                <li>
                  <a href="https://x.com/AnimeHOTorNOT" target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap">
                    Twitter
                  </a>
                </li>
                <li>
                  <a href="https://facebook.com/AnimeHOTorNOT" target="_blank" rel="noopener noreferrer" className="text-sm text-white/80 hover:text-white transition-colors whitespace-nowrap">
                    Facebook
                  </a>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="text-sm font-semibold mb-4">Feedback</h4>
              <p className="text-sm text-white/80 mb-4">
                Help us improve! Share your feedback or report bugs.
              </p>
              <button
                onClick={() => setShowFeedbackForm(true)}
                className="px-4 py-2 text-sm font-medium text-pink-600 bg-white rounded-lg hover:bg-white/90 transition-colors whitespace-nowrap cursor-pointer"
              >
                Submit Feedback
              </button>
            </div>
          </div>

          <div className="mt-8 pt-8 border-t border-white/20 text-center">
            <p className="text-sm text-white/80">
              © 2026 Anime HOT or NOT. All rights reserved.
            </p>
          </div>
        </div>
      </footer>

      {/* Suggestion Form Modal */}
      {showSuggestionForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full">
            <div className="px-6 py-4 flex items-center justify-between border-b border-gray-200">
              <h3 className="text-xl font-bold text-gray-900">Suggest Character or Series</h3>
              <button
                type="button"
                onClick={() => setShowSuggestionForm(false)}
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <form id="suggestion-form" data-readdy-form onSubmit={handleSubmit} className="p-6 space-y-4">
              <div>
                <label htmlFor="animeSeries" className="block text-sm font-medium text-gray-700 mb-1">
                  Anime Series (Optional)
                </label>
                <input
                  type="text"
                  id="animeSeries"
                  name="animeSeries"
                  value={formData.animeSeries}
                  onChange={(e) => setFormData({ ...formData, animeSeries: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
                  placeholder="e.g., Naruto, One Piece"
                />
              </div>

              <div>
                <label htmlFor="characterName" className="block text-sm font-medium text-gray-700 mb-1">
                  Character Name (Optional)
                </label>
                <input
                  type="text"
                  id="characterName"
                  name="characterName"
                  value={formData.characterName}
                  onChange={(e) => setFormData({ ...formData, characterName: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
                  placeholder="e.g., Naruto Uzumaki"
                />
              </div>

              <div>
                <label htmlFor="details" className="block text-sm font-medium text-gray-700 mb-1">
                  Additional Details (Optional)
                </label>
                <textarea
                  id="details"
                  name="details"
                  rows={4}
                  maxLength={500}
                  value={formData.details}
                  onChange={(e) => setFormData({ ...formData, details: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-pink-500 resize-none"
                  placeholder="Any additional information... (max 500 characters)"
                />
                <p className="text-xs text-gray-500 mt-1">{formData.details.length}/500 characters</p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-md text-sm">
                  <i className="ri-check-line mr-2"></i>
                  Thank you! Your suggestion has been submitted successfully.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-md text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  Something went wrong. Please try again.
                </div>
              )}

              <div className="flex gap-3 pt-2">
                <button
                  type="button"
                  onClick={() => setShowSuggestionForm(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex-1 px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-md text-sm font-medium hover:from-pink-600 hover:to-purple-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Suggestion'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Feedback Form Modal */}
      {showFeedbackForm && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg max-w-md w-full">
            <div className="px-6 py-4 flex items-center justify-between border-b border-gray-200">
              <h3 className="text-xl font-bold text-gray-900">Submit Feedback</h3>
              <button
                type="button"
                onClick={() => setShowFeedbackForm(false)}
                className="w-8 h-8 flex items-center justify-center text-gray-400 hover:text-gray-600 transition-colors cursor-pointer"
              >
                <i className="ri-close-line text-2xl"></i>
              </button>
            </div>

            <form id="feedback-form" data-readdy-form onSubmit={handleFeedbackSubmit} className="p-6 space-y-4">
              <div>
                <label htmlFor="feedbackType" className="block text-sm font-medium text-gray-700 mb-1">
                  Type *
                </label>
                <select
                  id="feedbackType"
                  name="feedbackType"
                  required
                  value={feedbackData.feedbackType}
                  onChange={(e) => setFeedbackData({ ...feedbackData, feedbackType: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
                >
                  <option value="feedback">General Feedback</option>
                  <option value="bug">Bug Report</option>
                  <option value="feature">Feature Request</option>
                </select>
              </div>

              <div>
                <label htmlFor="subject" className="block text-sm font-medium text-gray-700 mb-1">
                  Subject *
                </label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  required
                  value={feedbackData.subject}
                  onChange={(e) => setFeedbackData({ ...feedbackData, subject: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-pink-500"
                  placeholder="Brief summary of your feedback"
                />
              </div>

              <div>
                <label htmlFor="message" className="block text-sm font-medium text-gray-700 mb-1">
                  Message *
                </label>
                <textarea
                  id="message"
                  name="message"
                  rows={5}
                  maxLength={500}
                  required
                  value={feedbackData.message}
                  onChange={(e) => setFeedbackData({ ...feedbackData, message: e.target.value })}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-pink-500 resize-none"
                  placeholder="Please provide details... (max 500 characters)"
                />
                <p className="text-xs text-gray-500 mt-1">{feedbackData.message.length}/500 characters</p>
              </div>

              {submitStatus === 'success' && (
                <div className="bg-green-50 border border-green-200 text-green-800 px-4 py-3 rounded-md text-sm">
                  <i className="ri-check-line mr-2"></i>
                  Thank you! Your feedback has been submitted successfully.
                </div>
              )}

              {submitStatus === 'error' && (
                <div className="bg-red-50 border border-red-200 text-red-800 px-4 py-3 rounded-md text-sm">
                  <i className="ri-error-warning-line mr-2"></i>
                  Something went wrong. Please try again.
                </div>
              )}

              <div className="flex gap-3 pt-2">
                <button
                  type="button"
                  onClick={() => setShowFeedbackForm(false)}
                  className="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-md text-sm font-medium hover:bg-gray-50 transition-colors whitespace-nowrap cursor-pointer"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={isSubmitting}
                  className="flex-1 px-4 py-2 bg-gradient-to-r from-pink-500 to-purple-600 text-white rounded-md text-sm font-medium hover:from-pink-600 hover:to-purple-700 transition-all disabled:opacity-50 disabled:cursor-not-allowed whitespace-nowrap cursor-pointer"
                >
                  {isSubmitting ? 'Submitting...' : 'Submit Feedback'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
}
